/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createLog2 } from '../../factoriesNumber.js';
export var log2Dependencies = {
  typedDependencies,
  createLog2
};